import { useTheme } from '@mui/material';

export const TermsAndConditionsContent = () => {
  const theme = useTheme();
  return (
    <div>
      <p style={{ lineHeight: 2 }}>
        <strong>
          <span style={{ fontSize: '24px' }}>IMPORTANT NOTICE:</span>
        </strong>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          XCIPTV Player Ultra Stream is designed to be used with users’ own created content or created
          playlists with legal content.
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          XCIPTV Player Ultra Stream does not endorse the streaming of copyright protected material without
          permission of the copyright holder. We Expeditiously Act on Any Copyright Complaint And
          May Suspend Or Terminate Your Account.
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          XCIPTV Player Ultra Stream Application only displays the content added by the User and plays the
          User Content in the player.
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          XCIPTV Player Ultra Stream does not provide any content or playlists. XCIPTV Player Ultra Stream can play
          extensions such as 3g2, 3gp, 3gp2, 3gpp, amv, asf, avi, divx, drc, dv, f4v, flv, gvi, gxf,
          webm, wm, wmv, wtv, xesc, m1v, m2v, m2t, m2ts, m4v, mkv, mov, mp2, mp2v, mp4, mp4v, mpe,
          mpeg, mpeg1, mpeg2, mpeg4, mpg, mpv2, rec, rm, rmvb, tod, ts, tts, vob, vro, Live stream
          IPTV support.
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          XCIPTV Player Ultra Stream allows the users to load content (local data) from their device or play
          the playlist available at Xtream Codes API. In addition to this, the users can also load
          single streams from the URLs they enter in the play a single stream option. XCIPTV Player Ultra Stream Application means the mobile application available on the Apple Store, Google Play
          Store and on the web page of the XCIPTV Player Ultra Stream.
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <strong>
          <span>
            <br />
          </span>
        </strong>
      </p>
      <p style={{ lineHeight: 2 }}>
        <strong>
          <span style={{ fontSize: '24px' }}>INTRODUCTION</span>
        </strong>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          Thanks for choosing XCIPTV Player Ultra Stream (“XCIPTV Player Ultra Stream”, “IPTV”, “Player“ “we,” “us,”
          “our”). XCIPTV Player Ultra Stream provides an advanced IPTV player mobile application for the
          Android and iOS platforms for playing your own content i.e. photos, videos and streams.
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          By signing up or otherwise using the XCIPTV Player Ultra Stream mobile application, websites and
          user interfaces, (collectively, “XCIPTV Player Ultra Stream“ Application) that is made available
          through our Website, Play Store, App Store or otherwise available to you, you understand
          and agree you have entered into a binding contract with XCIPTV Player Ultra Stream.
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          Your agreement with us includes these Terms and any additional terms that you agree to, as
          discussed in the Entire Agreement section below, other than terms with any third parties
          (collectively, the “Agreements”). The Agreements include terms regarding future changes to
          the Agreements, privacy policy, copyright infringement complaint process, disclaimers on
          the mobile applications, limitations of liability, privacy, waiver of class actions, and
          resolution of disputes by arbitration instead of in court(s).
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          You acknowledge that you have read and understood the Agreements, accept these Agreements,
          and agree to be bound by them. If you don’t agree with (or cannot comply with) the
          Agreements, then you must not access and/or use XCIPTV Player Ultra Stream.
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          In order to use the XCIPTV Player Ultra Stream and access any Content, you need to (1) be 18 years
          or older, or be 13 years or older and have your parent or guardian’s consent to the
          Agreements, and (2) have the power to enter a binding contract with us and not be barred
          from doing so under any applicable or governing laws. You also promise that any
          registration information that you submit to XCIPTV Player Ultra Stream is true, accurate, and
          complete, and you would notify XCIPTV Player Ultra Stream in case of a change in any information so
          provided.
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <strong>
          <span>
            <br />
          </span>
        </strong>
      </p>
      <p style={{ lineHeight: 2 }}>
        <strong>
          <span style={{ fontSize: '24px' }}>CHANGES TO THE AGREEMENTS</span>
        </strong>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          Occasionally we may make changes to the Agreements. When we make material changes to the
          Agreements, we may provide you with notice as appropriate under the circumstances, e.g.,
          by displaying a prominent notice within the Application or by sending you an email. In
          some cases, we will notify you in advance, and your continued use of the XCIPTV Player Ultra Stream
          after the changes have been made will constitute your acceptance of the changes. Please
          therefore make sure you read any such notice carefully.
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          If you do not wish to continue using our Application under the new version of the
          Agreements, you may terminate your account by contacting us.
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <strong>
          <span>
            <br />
          </span>
        </strong>
      </p>
      <p style={{ lineHeight: 2 }}>
        <strong>
          <span style={{ fontSize: '24px' }}>XCIPTV Player Ultra Stream MOBILE APPLICATION</span>
        </strong>
      </p>
      <p style={{ lineHeight: 2 }}>
        <strong>
          <span style={{ fontSize: '18px' }}>BASIC VERSION</span>
        </strong>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          XCIPTV Player Ultra Stream is available for free and you can only watch your own content i.e.
          photos, videos and streams without any costs. It is important to note that we do not
          provide any content whatsoever.
          <br />
          Technical issues could occur in technology products and we may interrupt the access to
          XCIPTV Player Ultra Stream for any maintenance or improvements to the player. You may be notified of
          such upgrades or maintenance by XCIPTV Player Ultra Stream.
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <strong>
          <span style={{ fontSize: '18px' }}>
            <br />
          </span>
        </strong>
      </p>
      <p style={{ lineHeight: 2 }}>
        <strong>
          <span style={{ fontSize: '18px' }}>PREMIUM VERSION&nbsp;</span>
        </strong>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          You may purchase our Premium version of XCIPTV Player Ultra Stream by paying a fee in advance on a
          monthly basis or some other recurring interval basis disclosed to you prior to your
          purchase/subscription of Premium version of XCIPTV Player Ultra Stream. We may change the price for
          the Premium version from time to time and will communicate any price changes to you in
          advance and, if applicable, how to accept those changes. Subject to applicable law, you
          accept the new price by continuing to use the XCIPTV Player Ultra Stream after the price change
          takes effect. If you do not agree with a price change, you have the right to reject the
          change by unsubscribing from the Paid Subscription prior to the price change going into
          effect.
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          By purchasing or subscribing to the premium version of the XCIPTV Player Ultra Stream, you will be
          having the privilege to unlock, access and use following features in addition to the
          features included in the Basic Version:
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          <span>
            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;1.<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
        </span>
        <span>Whole Search</span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          <span>
            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;2.<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
        </span>
        <span>Ability to add External EPG Sources</span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          <span>
            &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; 3.<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
        </span>
        <span>Picture-In-Picute Feature</span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          <span>
            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;4.<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
        </span>
        <span>Parental Control</span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          <span>
            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;5.<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
        </span>
        <span>Chrome Casting feature</span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          <span>
            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;6.<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
        </span>
        <span>External Player adding feature</span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          <span>
            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;7.<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
        </span>
        <span>and other features included in the Basic Version.</span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          <br />
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <strong>
          <span style={{ fontSize: '18px' }}>RENEWAL: CANCELLATION OF PREMIUM VERSION</span>
        </strong>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          You hereby understand and agree that your subscription and payment to XCIPTV Player Ultra Stream for
          the Premium Version will automatically renew at the end of the applicable subscription
          period, unless you cancel your subscription before the end of the then-current
          subscription period by going to the account section within in the mobile application and
          cancelling the subscription to the Premium version. The cancellation will take effect the
          day after the last day of the current subscription period. In consonance with industry
          standards, we do not provide refunds or credits for any partial subscription periods.
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          <br />
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <strong>
          <span style={{ fontSize: '18px' }}>INTELLECTUAL PROPERTY RIGHTS</span>
        </strong>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          The XCIPTV Player Ultra Stream is the property of Auxo Streaming LLC. We own exclusive Intellectual
          Property to our player and any trademarks, patents, copyrights and proprietary code
          therewith. We grant you limited, non-exclusive, revocable permission to use the XCIPTV Player Ultra Stream to play your own content (collectively, “Access”). This Access shall remain in
          effect until and unless terminated by you or XCIPTV Player Ultra Stream. We may terminate your
          Access on grounds of any complaint alleging your infringement of intellectual property
          rights of others.
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          All XCIPTV Player Ultra Stream’s trademarks, trade names, logos, domain names, and any other
          features of the XCIPTV Player Ultra Stream brand (“Auxo Streaming LLC”) are the sole property of
          XCIPTV Player Ultra Stream or its licensors.
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          <br />
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <strong>
          <span style={{ fontSize: '18px' }}>4.1 COPYRIGHT AND INTELLECTUAL PROPERTY RIGHTS</span>
        </strong>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          <span>
            1.<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
        </span>
        <span>
          The User acknowledges and agrees that XCIPTV Player Ultra Stream is the sole owner of all copyrights
          and intellectual property rights regarding XCIPTV Player Ultra Stream worldwide, regardless of
          whether or not said copyrights and intellectual property rights are registered in any
          given region.
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          <span>
            2.<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
        </span>
        <span>
          All copyrights and intellectual property rights regarding the content created by XCIPTV Player Ultra Stream in relation to the mobile application are the property of XCIPTV Player Ultra Stream.
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          <span>
            3.<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
        </span>
        <span>
          Any copyrights and intellectual property rights for content related to Services that are
          not created by XCIPTV Player Ultra Stream and/or are offered/provided by other companies or parties
          are the property of their respective owners.
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          <span>
            4.<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
        </span>
        <span>
          The User guarantees that he or she has the requisite copyrights or permission to the
          content they wish to play using the XCIPTV Player Ultra Stream mobile application.
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          <span>
            5.<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
        </span>
        <span>
          The User agrees not to modify, rent, lend, sell, or otherwise alter or distribute any
          content, nor create any derivative works based on said content, unless they have been
          explicitly authorized in writing by the respective copyright owner to do so.
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          <span>
            6.<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
        </span>
        <span>
          The User acknowledges that he or she is solely responsible for protecting and enforcing
          his or her copyrights for content displayed or viewed through the use of Application, and
          agrees that XCIPTV Player Ultra Stream has no obligation or responsibility to protect these rights
          on behalf of the User.
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          <span>
            7.<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
        </span>
        <span>
          You agree to abide by these Terms, Privacy Policy and Copyright Infringement Redressal
          Policy and not to use the XCIPTV Player Ultra Stream, or any part thereof in any manner not
          expressly permitted by the Agreements. You must not infringe on intellectual property of
          our player or any third-party copyrights by playing any content for which you do not have
          any authorisation.
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          <span>
            8.<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
        </span>
        <span>
          XCIPTV Player Ultra Stream shall not be liable for your usage of the player that results into
          violation of copyrights of any person, company or any entity for merely providing
          transmission, routing, or providing connections for, content that you seek to play through
          the Application. XCIPTV Player Ultra Stream does not seek for you to initiate any stream, access any
          content etc. It is in your sole discretion that you choose the player to access, load,
          stream content that you decide to so do.
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          <span>
            9.<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
        </span>
        <span>
          Except for the rights expressly granted to you in the Agreements, XCIPTV Player Ultra Stream grants
          no right, title, or interest to you in the XCIPTV Player Ultra Stream mobile application.
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <strong>
          <span>
            <br />
          </span>
        </strong>
      </p>
      <p style={{ lineHeight: 2 }}>
        <strong>
          <span style={{ fontSize: '18px' }}>USER-GENERATED CONTENT</span>
        </strong>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          You are solely responsible for all the Content that you play or stream or access. XCIPTV Player Ultra Stream is not responsible for Content you access nor does it endorse any opinion
          contained in any Content. YOU AGREE THAT IF ANYONE BRINGS A CLAIM AGAINST XCIPTV Player Ultra Stream
          OR ITS AFFILIATES, RELATED TO USER CONTENT THAT YOU ACCESS, THEN, YOU ARE ONLY SOLELY
          RESPONSIBLE FOR THE CONTENT YOU ACCESS AND NOT XCIPTV Player Ultra Stream AND TO THE EXTENT
          PERMISSIBLE UNDER LOCAL LAW, YOU WILL INDEMNIFY AND HOLD XCIPTV Player Ultra Stream HARMLESS FROM
          AND AGAINST ALL DAMAGES, LOSSES, AND EXPENSES OF ANY KIND (INCLUDING ATTORNEY FEES AND
          COSTS) ARISING OUT OF SUCH CLAIM.
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <strong>
          <span>
            <br />
          </span>
        </strong>
      </p>
      <p style={{ lineHeight: 2 }}>
        <strong>
          <span style={{ fontSize: '18px' }}>RIGHTS YOU GRANT US</span>
        </strong>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          <span>
            1.<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
        </span>
        <span>
          In consideration for the rights granted to you under the Agreements, you grant us the
          right to allow the XCIPTV Player Ultra Stream to use the processor, bandwidth, and storage hardware
          on your Device in order to facilitate the operation of the Application,
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          <span>
            2.<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
        </span>
        <span>
          .If you provide feedback, ideas or suggestions to XCIPTV Player Ultra Stream in connection with the
          XCIPTV Player Ultra Stream Application (“Feedback”), you acknowledge that the Feedback is not
          confidential and you authorize XCIPTV Player Ultra Stream to use that Feedback without restriction
          and without payment to you. Feedback is considered a type of User Content.
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          <span>
            3.<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
        </span>
        <span>
          Aside from the rights specifically granted herein, you retain ownership of all rights,
          including intellectual property rights, in the User Content. Where applicable and
          permitted under applicable law, you also agree to waive and not enforce any “moral rights”
          or equivalent rights, such as your right to be identified as the author of any User
          Content, including Feedback, and your right to object to derogatory treatment of such User
          Content.
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <strong>
          <span>
            <br />
          </span>
        </strong>
      </p>
      <p style={{ lineHeight: 2 }}>
        <strong>
          <span style={{ fontSize: '18px' }}>USER GUIDELINES</span>
        </strong>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          XCIPTV Player Ultra Stream respects all laws and agreements and intellectual property rights and
          expects you to do the same. You must follow these rules and should encourage other users
          to do the same.
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <strong>
          <span>
            <br />
          </span>
        </strong>
      </p>
      <p style={{ lineHeight: 2 }}>
        <strong>
          <span>The following is not permitted for any reason:</span>
        </strong>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          <span>
            1.<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
        </span>
        <span>
          Using the Application for doing anything that is illegal or which may be deemed illegal in
          the territory where you are using our Application.
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          <span>
            2.<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
        </span>
        <span>
          Using the Application for watching, streaming, broadcasting, publicly making available,
          performing, displaying to the public, recording, transferring, reproducing, copying, or
          redistributing content which is not expressly permitted under the Agreements or applicable
          law or which otherwise infringes the intellectual property rights (such as copyright) of
          XCIPTV Player Ultra Stream, any person or any entity.
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          <span>
            3.<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
        </span>
        <span>
          Transferring copies of cached third-party Content from an authorized Device to any other
          Device via any means;
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          <span>
            4.<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
        </span>
        <span>
          Reverse-engineering, decompiling, disassembling, modifying, or creating derivative works
          of the XCIPTV Player Ultra Stream Application or any part thereof except to the extent permitted by
          applicable law;
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          <span>
            5.<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
        </span>
        <span>
          Circumventing any technology used by XCIPTV Player Ultra Stream, its licensors, or any third party
          to protect the Application;
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          <span>
            6.<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
        </span>
        <span>
          Selling, renting, sublicensing or leasing of any part of the XCIPTV Player Ultra Stream Application;
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          <span>
            7.<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
        </span>
        <span>
          Circumventing any territorial restrictions applied by XCIPTV Player Ultra Stream or its licensors;
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          <span>
            8.<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
        </span>
        <span>
          Removing or altering any copyright, trademark, or other intellectual property notices
          contained on the Application or provided through the Application (including for the
          purpose of disguising or changing any indications of the ownership or source of any
          Content);
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          <span>
            9.<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
        </span>
        <span>
          Providing your password to any other person or using any other person’s username and
          password;
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          <span>10.</span>
        </span>
        <span>
          “Crawling” the XCIPTV Player Ultra Stream Application or otherwise using any automated means
          (including bots, scrapers, and spiders) to view, access or collect information from XCIPTV Player Ultra Stream Application
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          <span>11.</span>
        </span>
        <span>
          Selling a user account or otherwise accepting or offering to accept any compensation,
          financial or otherwise, to influence the name of an account or the content included on an
          account or playlist; or
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          <span>12.</span>
        </span>
        <span>Artificially promoting Content by automated means or otherwise.</span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          <br />
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          Please respect XCIPTV Player Ultra Stream, the owners of the Content, and other users of the XCIPTV Player Ultra Stream Application. Don’t engage in any activity, post any User Content, or register
          and/or use a username, which is or includes material that:
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          <span>
            ·<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
        </span>
        <span>is offensive, abusive, defamatory, pornographic, threatening, or obscene;</span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          <span>
            ·<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
        </span>
        <span>
          is illegal, or intended to promote or commit an illegal act of any kind, including
          violations of intellectual property rights, privacy rights, or proprietary rights of KXCIPTV Player Ultra Stream or a third party;
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          <span>
            ·<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
        </span>
        <span>
          includes your password or purposely includes any other user’s password or purposely
          includes personal data of third parties or is intended to solicit such personal data;
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          <span>
            ·<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
        </span>
        <span>
          includes malicious content such as malware, Trojan horses, or viruses, or otherwise
          interferes with any user’s access to the Application;
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          <span>
            ·<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
        </span>
        <span>is intended to or does harass or bully other users;</span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          <span>
            ·<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
        </span>
        <span>
          impersonates or misrepresents your affiliation with another user, person, or entity, or is
          otherwise fraudulent, false, deceptive, or misleading;
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          <span>
            ·<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
        </span>
        <span>
          involves the transmission of unsolicited mass mailings or other forms of spam, junk mail,
          chain letters, or similar;
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          <span>
            ·<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
        </span>
        <span>
          involves commercial or sales activities, such as advertising, promotions, contests,
          sweepstakes, or pyramid schemes, that are not expressly authorized by XCIPTV Player Ultra Stream;
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          <span>
            ·<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
        </span>
        <span>
          links to, references, or otherwise promotes commercial products or services, except as
          expressly authorized by XCIPTV Player Ultra Stream;
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          <span>
            ·<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
        </span>
        <span>
          interferes with or in any way disrupts the XCIPTV Player Ultra Stream Application, tampers with,
          breaches, or attempts to probe, scan, or test for vulnerabilities in the XCIPTV Player Ultra Stream
          Application, or any of XCIPTV Player Ultra Stream’s security components, authentication measures or
          any other protection measures applicable to the Application, or any part thereof; or
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          <span>
            ·<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
        </span>
        <span>conflicts with the Agreements, as determined by XCIPTV Player Ultra Stream.</span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          <span>
            ·<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
        </span>
        <span>
          You acknowledge and agree that posting any User Content that violates these User
          guidelines (or that XCIPTV Player Ultra Stream reasonably believes violates these User guidelines)
          may result in immediate termination or suspension of your XCIPTV Player Ultra Stream account. You
          also agree that XCIPTV Player Ultra Stream may reclaim your username for any reason.
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          <span>
            ·<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
        </span>
        <span>
          &nbsp;XCIPTV Player Ultra Stream has no responsibility for your choices to view/watch material on
          the Application or the content you watch on the XCIPTV Player Ultra Stream Application.
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          Your password protects your user account, and you are solely responsible for keeping your
          password confidential and secure. You understand that you are responsible for all use
          (including any unauthorized use) of your username and password on the Application. If your
          username or password is lost or stolen, or if you believe there has been unauthorized
          access to your account by a third party, you must notify us immediately and change your
          password as soon as possible.
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <strong>
          <span>
            <br />
          </span>
        </strong>
      </p>
      <p style={{ lineHeight: 2 }}>
        <strong>
          <span style={{ fontSize: '18px' }}>INFRINGEMENT AND REPORTING USER CONTENT</span>
        </strong>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          XCIPTV Player Ultra Stream respects the rights of intellectual property owners and acts
          expeditiously on any complaints relating to copyrights violations. In this regard a
          specific Copyright Infringement Redressal Policy has been set up which can be accessed
          here (
          <a
            style={{ color: theme.palette.text.primary }}
            href="http://www.streamingtechllc.com/copyright-complaint"
          >
            <span>www.streamingtechllc.com/copyright-complaint</span>
          </a>
          ). If you believe that any Content infringes your intellectual property rights or other
          rights, please contact XCIPTV Player Ultra Stream and notify us through our legal partner, Prodigy
          Legal LLP, at&nbsp;info@prodigylegal.com&nbsp;. XCIPTV Player Ultra Stream may in its sole
          discretion suspend the account of such users from the Application, or take other steps
          that XCIPTV Player Ultra Stream deems appropriate, without prior notification to the user or other
          party who supplied or posted that Content. If such user or other party believes that the
          Content is not infringing, he or she may in certain circumstances submit a
          counter-notification to XCIPTV Player Ultra Stream with a request to restore their disabled account,
          which XCIPTV Player Ultra Stream may or may not honour, in XCIPTV Player Ultra Stream sole discretion. For
          Copyright complaints, please use our copyright complaint policy at&nbsp;
        </span>
        <span>
          <a
            style={{ color: theme.palette.text.primary }}
            href="http://www.streamingtechllc.com/copyright-complaint"
          >
            <span>www.streamingtechllc.com/copyright-complaint</span>
          </a>
        </span>
        <span>.</span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          XCIPTV Player Ultra Stream does not store any content accessed by the Users or keep cached files, or
          has any interaction with the content so posted by the Users. Therefore, the only remedy in
          cases of a copyright violation for XCIPTV Player Ultra Stream is the removal of account that
          accessed such copyrighted content or a warning towards removal of such account whatever
          XCIPTV Player Ultra Stream deem fit.
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <strong>
          <span>
            <br />
          </span>
        </strong>
      </p>
      <p style={{ lineHeight: 2 }}>
        <strong>
          <span style={{ fontSize: '18px' }}>SERVICE LIMITATIONS AND MODIFICATIONS</span>
        </strong>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          XCIPTV Player Ultra Stream will make reasonable efforts to keep the XCIPTV Player Ultra Stream Application
          operational. However, certain technical difficulties, maintenance or testing, or updates
          required to reflect changes in relevant laws and regulatory requirements, may, from time
          to time, result in temporary interruptions. XCIPTV Player Ultra Stream reserves the right,
          periodically and at any time, to modify or discontinue, temporarily or permanently,
          functions and features of the XCIPTV Player Ultra Stream Application, with advance notice where
          possible, all without liability to you, except where prohibited by law, for any
          interruption, modification, or discontinuation of the XCIPTV Player Ultra Stream Application or any
          function or feature thereof.
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          <span>
            1.<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
        </span>
        <span>
          The Company does not guarantee that the data and other information provided through the
          Software are accurate or will be in compliance with applicable copyright laws, except for
          data and information that are directly created or prepared by the Company.
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          <span>
            2.<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
        </span>
        <span>
          The Company is not responsible for any losses or damage incurred to the user due to the
          installation, use or non-use of the Software except where such losses or damages are
          caused by the willful misconduct or gross negligence of the Company.
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          <span>
            3.<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
        </span>
        <span>
          The Company is not responsible for any loss of actual or anticipated profits of the user
          from their use of the Software.
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          <span>
            4.<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
        </span>
        <span>
          The Company is not responsible for, and will not be obligated to be involved in, any
          disputes that arise between users and between a user and a third party in connection with
          their use of the XCIPTV Player Ultra Stream Application.
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <strong>
          <span>
            <br />
          </span>
        </strong>
      </p>
      <p style={{ lineHeight: 2 }}>
        <strong>
          <span style={{ fontSize: '18px' }}>CUSTOMER SUPPORT</span>
        </strong>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          For customer support with account-related and payment-related questions (“Customer Support
          Queries”), please submit a ticket to our Customer Service department using form available
          on the Contact Us page on our website. We will use reasonable endeavours to respond to all
          Customer Support Queries within a reasonable time frame but we make no promises that any
          Customer Support Queries will be responded to within any particular time frame and/or that
          we will be able to answer any such queries.
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <strong>
          <span>
            <br />
          </span>
        </strong>
      </p>
      <p style={{ lineHeight: 2 }}>
        <strong>
          <span>EXPORT CONTROL</span>
        </strong>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          XCIPTV Player Ultra Stream Application may be subject to U.S. export and re-export control laws and
          regulations or similar laws applicable in other jurisdictions, including the Export
          Administration Regulations (“EAR”) maintained by the U.S. Department of Commerce, trade
          and economic sanctions maintained by the Treasury Department’s Office of Foreign Assets
          Control (“OFAC”), and the International Traffic in Arms Regulations (“ITAR”) maintained by
          the Department of State. You warrant that you are (1) not located in any country to which
          the United States has embargoed goods or has otherwise applied any economic sanctions; and
          (2) not a denied party as specified in any applicable export or re-export laws or
          regulations or similar laws applicable in other jurisdictions.
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          You agree to comply with all applicable export and reexport control laws and regulations,
          including the EAR, trade and economic sanctions maintained by OFAC, and the ITAR.
          Specifically, you agree that you shall not – directly or indirectly – sell, export,
          reexport, transfer, divert, or otherwise dispose of the XCIPTV Player Ultra Stream Application
          (including products derived from or based on such technology) received from XCIPTV Player Ultra Stream under the Agreements to any destination, entity, or person prohibited by any
          applicable laws or regulations of the United States or any other jurisdiction without
          obtaining prior authorization from the competent government authorities as required by
          those laws and regulations.
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <strong>
          <span>
            <br />
          </span>
        </strong>
      </p>
      <p style={{ lineHeight: 2 }}>
        <strong>
          <span style={{ fontSize: '18px' }}>TERM AND TERMINATION</span>
        </strong>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          The Agreements will continue to apply to you until terminated by either you or XCIPTV Player Ultra Stream. However, you acknowledge and agree that the perpetual license granted by you in
          relation to Feedback, is irrevocable and will therefore continue after expiry or
          termination of any of the Agreements for any reason. XCIPTV Player Ultra Stream may terminate the
          Agreements or suspend your access to the XCIPTV Player Ultra Stream Application at any time,
          including in the event of your actual or suspected unauthorized use of the XCIPTV Player Ultra Stream Application, or non-compliance with the Agreements, or if we withdraw the access to
          Application (in which case we shall provide you with reasonable notice in advance of doing
          so). If you or XCIPTV Player Ultra Stream terminate the Agreements, or if XCIPTV Player Ultra Stream suspends
          your access to the XCIPTV Player Ultra Stream Application, you agree that XCIPTV Player Ultra Stream shall
          have no liability or responsibility to you, and XCIPTV Player Ultra Stream will not refund any
          amounts that you have already paid, to the fullest extent permitted under applicable law.
          You may terminate the Agreements at any time. This section will be enforced to the extent
          permissible by applicable law.
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          Sections 7, 8, 9, 11, 15, 16, 17, 18, 19, 20, 21, 22, and 23 herein, as well as any other
          sections of the Agreements that, either explicitly or by their nature, must remain in
          effect even after termination of the Agreements, shall survive termination.
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <strong>
          <span>
            <br />
          </span>
        </strong>
      </p>
      <p style={{ lineHeight: 2 }}>
        <strong>
          <span>WARRANTY DISCLAIMER</span>
        </strong>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          YOU UNDERSTAND AND AGREE THAT THE XCIPTV Player Ultra Stream APPLICATION IS PROVIDED “AS IS” AND “AS
          AVAILABLE,” WITHOUT EXPRESS OR IMPLIED WARRANTY OR CONDITION OF ANY KIND. XCIPTV Player Ultra Stream
          AND ALL OWNERS OF THE CONTENT MAKE NO REPRESENTATIONS AND DISCLAIM ANY WARRANTIES OR
          CONDITIONS OF SATISFACTORY QUALITY, MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR
          NON-INFRINGEMENT. XCIPTV Player Ultra Stream DOES NOT WARRANT THAT THE XCIPTV Player Ultra Stream APPLICATION
          IS FREE OF MALWARE OR OTHER HARMFUL COMPONENTS. IN ADDITION, XCIPTV Player Ultra Stream MAKES NO
          REPRESENTATION NOR DOES IT WARRANT, ENDORSE, GUARANTEE, OR ASSUME RESPONSIBILITY FOR ANY
          THIRD-PARTY APPLICATIONS (OR THE CONTENT THEREOF), USER CONTENT, DEVICES OR ANY OTHER
          PRODUCT OR SERVICE ADVERTISED, PROMOTED OR OFFERED BY A THIRD PARTY ON OR THROUGH THE XCIPTV Player Ultra Stream APPLICATION AND XCIPTV Player Ultra Stream IS NOT RESPONSIBLE OR LIABLE FOR ANY
          TRANSACTION BETWEEN YOU AND THIRD PARTY PROVIDERS OF THE FOREGOING. NO ADVICE OR
          INFORMATION WHETHER ORAL OR IN WRITING OBTAINED BY YOU FROM IPTV XCIPTV Player Ultra Stream SHALL
          CREATE ANY WARRANTY ON BEHALF OF XCIPTV Player Ultra Stream. THIS SECTION APPLIES TO THE FULLEST
          EXTENT PERMITTED BY APPLICABLE LAW.
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>THIS SECTION DOES NOT AFFECT YOUR STATUTORY RIGHTS AS A CONSUMER.</span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <strong>
          <span>
            <br />
          </span>
        </strong>
      </p>
      <p style={{ lineHeight: 2 }}>
        <strong>
          <span>LIMITATION AND TIME FOR FILING</span>
        </strong>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          <span>
            1.<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
        </span>
        <span>
          The Company does not guarantee that the data and other information provided through the
          Application are accurate or will be in compliance with applicable copyright laws, except
          for data and information that are directly created or prepared by the Company.
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          <span>
            2.<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
        </span>
        <span>
          The Company is not responsible for any losses or damage incurred to the user due to the
          installation, use or non-use of the Software except where such losses or damages are
          caused by the willful misconduct or gross negligence of the Company.
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          <span>
            3.<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
        </span>
        <span>
          The Company is not responsible for any loss of actual or anticipated profits of the user
          from their use of the Application.
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          <span>
            4.<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
        </span>
        <span>
          The Company is not responsible for, and will not be obligated to be involved in, any
          disputes that arise between users and between a user and a third party in connection with
          their use of the Application.
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          YOU AGREE THAT YOUR SOLE AND EXCLUSIVE REMEDY FOR ANY PROBLEMS OR DISSATISFACTION WITH THE
          XCIPTV Player Ultra Stream APPLICATION IS TO UNINSTALL THE XCIPTV Player Ultra Stream APPLICATION AND TO STOP
          USING THE XCIPTV Player Ultra Stream APPLICATION. YOU AGREE THAT XCIPTV Player Ultra Stream HAS NO OBLIGATION
          OR LIABILITY ARISING FROM OR RELATED TO THIRD PARTY APPLICATIONS OR THE CONTENT THEREOF
          MADE AVAILABLE OR YOU ACCESS THROUGH OR IN CONNECTION WITH THE XCIPTV Player Ultra Stream
          APPLICATION, AND WHILE YOUR RELATIONSHIP WITH SUCH THIRD PARTY APPLICATIONS MAY BE
          GOVERNED BY SEPARATE AGREEMENTS WITH SUCH THIRD PARTIES, YOUR SOLE AND EXCLUSIVE REMEDY,
          AS WITH RESPECT TO XCIPTV Player Ultra Stream, FOR ANY PROBLEMS OR DISSATISFACTION WITH THIRD PARTY
          APPLICATIONS OR THE CONTENT THEREOF, IS TO UNINSTALL AND/OR STOP USING ANY SUCH THIRD
          PARTY APPLICATIONS.
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          IN NO EVENT WILL XCIPTV Player Ultra Stream, ITS OFFICERS, SHAREHOLDERS, EMPLOYEES, AGENTS,
          DIRECTORS, SUBSIDIARIES, AFFILIATES, SUCCESSORS, ASSIGNS, SUPPLIERS, OR LICENSORS BE
          LIABLE FOR (1) ANY INDIRECT, SPECIAL, INCIDENTAL, PUNITIVE, EXEMPLARY, OR CONSEQUENTIAL
          DAMAGES; (2) ANY LOSS OF USE, DATA, BUSINESS, OR PROFITS (WHETHER DIRECT OR INDIRECT), IN
          ALL CASES ARISING OUT OF THE USE OF OR INABILITY TO USE THE XCIPTV Player Ultra Stream APPLICATION,
          DEVICES THIRD PARTY APPLICATIONS, OR THIRD PARTY APPLICATION CONTENT, REGARDLESS OF LEGAL
          THEORY, WITHOUT REGARD TO WHETHER XCIPTV Player Ultra Stream HAS BEEN WARNED OF THE POSSIBILITY OF
          THOSE DAMAGES, AND EVEN IF A REMEDY FAILS OF ITS ESSENTIAL PURPOSE; OR (3) AGGREGATE
          LIABILITY FOR ALL CLAIMS RELATING TO THE XCIPTV Player Ultra Stream APPLICATION, THIRD PARTY
          APPLICATIONS, OR THIRD PARTY APPLICATION CONTENT MORE THAN THE AMOUNTS PAID BY YOU TO XCIPTV Player Ultra Stream DURING THE PRIOR TWELVE MONTHS IN QUESTION.
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          YOU AGREE THAT ANY CLAIM AGAINST XCIPTV Player Ultra Stream MUST BE COMMENCED (BY FILING A DEMAND
          FOR ARBITRATION UNDER SECTION (22.2) WITHIN ONE (1) YEAR AFTER THE DATE THE PARTY
          ASSERTING THE CLAIM FIRST KNOWS OR REASONABLY SHOULD KNOW OF THE ACT, OMISSION, OR DEFAULT
          GIVING RISE TO THE CLAIM; AND THERE SHALL BE NO RIGHT TO ANY REMEDY FOR ANY CLAIM NOT
          ASSERTED WITHIN THAT TIME PERIOD.
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>THIS SECTION APPLIES TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW.</span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <strong>
          <span>
            <br />
          </span>
        </strong>
      </p>
      <p style={{ lineHeight: 2 }}>
        <strong>
          <span>THIRD PARTY RIGHTS</span>
        </strong>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          You acknowledge and agree that the owners of the Content and certain distributors (such as
          app store providers) are intended beneficiaries of the Agreements and have the right to
          enforce the Agreements directly against you. Other than as set out in this section, the
          Agreements are not intended to grant rights to anyone except you and XCIPTV Player Ultra Stream, and
          in no event shall the Agreements create any third-party beneficiary rights. Furthermore,
          the rights to terminate, rescind, or agree to any variation, waiver, or settlement of the
          Agreements are not subject to the consent of any other person.
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          If you have downloaded the App from the Apple, Inc. (“Apple”) App Store or if you are
          using the App on an iOS device, you acknowledge that you have read, understood, and agree
          to the following notice regarding Apple. This Agreement is between you and XCIPTV Player Ultra Stream only, not with Apple, and Apple is not responsible for the Application and the
          content thereof. Apple has no obligation whatsoever to furnish any maintenance and support
          services with respect to the Application. In the event of any failure of the Application
          to conform to any applicable warranty, then you may notify Apple and Apple will refund any
          applicable purchase price for the App to you; and, to the maximum extent permitted by
          applicable law, Apple has no other warranty obligation whatsoever with respect to the
          Application. Apple is not responsible for addressing any claims by you or any third party
          relating to the Application or your possession and/or use of the Application, including:
          (1) product liability claims; (2) any claim that the Application fails to conform to any
          applicable legal or regulatory requirement; and (3) claims arising under consumer
          protection or similar legislation. Apple is not responsible for the investigation,
          defence, settlement and discharge of any third-party claim that the Application and/or
          your possession and use of the App infringe that third party’s intellectual property
          rights. You agree to comply with any applicable third-party terms, when using the
          Application. Apple, and Apple’s subsidiaries, are third party beneficiaries of this
          Agreement, and upon your acceptance of this Agreement, Apple will have the right (and will
          be deemed to have accepted the right) to enforce this Agreement against you as a
          third-party beneficiary of this Agreement. You hereby represent and warrant that (1) you
          are not located in a country that is subject to a U.S. Government embargo, or that has
          been designated by the U.S. Government as a “terrorist supporting” country; and (2) you
          are not listed on any U.S. Government list of prohibited or restricted parties.
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <strong>
          <span>
            <br />
          </span>
        </strong>
      </p>
      <p style={{ lineHeight: 2 }}>
        <strong>
          <span>ENTIRE AGREEMENT</span>
        </strong>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          Other than as stated in this section or as explicitly agreed upon in writing between you
          and XCIPTV Player Ultra Stream, the Agreements constitute all the terms and conditions agreed upon
          between you and XCIPTV Player Ultra Stream and supersede any prior agreements in relation to the
          subject matter of these Agreements, whether written or oral.
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <strong>
          <span>
            <br />
          </span>
        </strong>
      </p>
      <p style={{ lineHeight: 2 }}>
        <strong>
          <span>SEVERABILITY, WAIVER AND INTERPRETATION</span>
        </strong>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          <span>
            1.<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
        </span>
        <span>
          Unless as otherwise stated in the Agreements, should any provision of the Agreements be
          held invalid or unenforceable for any reason or to any extent, such invalidity or
          enforceability shall not in any manner affect or render invalid or unenforceable the
          remaining provisions of the Agreements, and the application of that provision shall be
          enforced to the extent permitted by law.
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          <span>
            2.<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
        </span>
        <span>
          Any failure by XCIPTV Player Ultra Stream or any third-party beneficiary to enforce the Agreements
          or any provision thereof shall not waive XCIPTV Player Ultra Stream or the applicable third-party
          beneficiary’s right to do so.
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          <span>
            3.<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
        </span>
        <span>
          As used in these Terms, the words “include” and “including,” and variations thereof, will
          be deemed to be followed by the words “without limitation.”
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <strong>
          <span>ASSIGNMENT</span>
        </strong>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          XCIPTV Player Ultra Stream may assign the Agreements, and any of its rights under the Agreements, in
          whole or in part, and XCIPTV Player Ultra Stream may delegate any of its obligations under the
          Agreements. You may not assign the Agreements, in whole or in part, nor transfer or
          sub-license your rights under the Agreements, to any third party.
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <strong>
          <span>
            <br />
          </span>
        </strong>
      </p>
      <p style={{ lineHeight: 2 }}>
        <strong>
          <span>INDEMNIFICATION</span>
        </strong>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          You agree to indemnify and hold XCIPTV Player Ultra Stream harmless from and against all damages,
          losses, and expenses of any kind (including reasonable attorney fees and costs) arising
          out of or related to: (1) your breach of the Agreements or any one of them; (2) any User
          Content you post or otherwise contribute; (3) any activity in which you engage on or
          through the XCIPTV Player Ultra Stream Application; and (4) your violation of any law or the rights
          of a third party.
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <strong>
          <span>
            <br />
          </span>
        </strong>
      </p>
      <p style={{ lineHeight: 2 }}>
        <strong>
          <span>GOVERNING LAW / JURISDICTION</span>
        </strong>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          The Agreements (and any non-contractual disputes/claims arising out of or in connection
          with them) are subject to the laws of India, without regard to the choice or conflicts of
          law principles. The Arbitration Agreement as explained in paragraph 22 applies to all
          users.
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <strong>
          <span>
            <br />
          </span>
        </strong>
      </p>
      <p style={{ lineHeight: 2 }}>
        <strong>
          <span>DISPUTE RESOLUTION AND ARBITRATION</span>
        </strong>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          You and XCIPTV Player Ultra Stream agree that any dispute, claim, or controversy between you and
          XCIPTV Player Ultra Stream arising in connection with or relating in any way to these Agreements or
          to your relationship with XCIPTV Player Ultra Stream as a user of Application (whether based in
          contract, tort, statute, fraud, misrepresentation, or any other legal theory, and whether
          the claims arise during or after the termination of the Agreements) will be determined by
          mandatory binding individual (not class) arbitration. You and XCIPTV Player Ultra Stream further
          agree that the arbitrator shall have the exclusive power to rule on his or her own
          jurisdiction, including any objections with respect to the existence, scope or validity of
          the Arbitration Agreement or to the arbitrability of any claim or counterclaim.
          Arbitration is more informal than a lawsuit in court. THERE IS NO JUDGE OR JURY IN
          ARBITRATION, AND COURT REVIEW OF AN ARBITRATION AWARD IS LIMITED. There may be more
          limited discovery than in court. The arbitrator must follow this agreement and can award
          the same damages and relief as a court (including attorney fees), except that the
          arbitrator may not award any relief, including declaratory or injunctive relief,
          benefiting anyone but the parties to the arbitration. This arbitration provision will
          survive termination of the Agreements.
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <strong>
          <span>
            <br />
          </span>
        </strong>
      </p>
      <p style={{ lineHeight: 2 }}>
        <strong>
          <span>NO CLASS OR REPRESENTATIVE PROCEEDINGS: CLASS ACTION WAIVER</span>
        </strong>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          YOU AND XCIPTV Player Ultra Stream AGREE THAT EACH MAY BRING CLAIMS AGAINST THE OTHER ONLY IN YOUR
          OR ITS INDIVIDUAL CAPACITY AND NOT AS A PLAINTIFF OR CLASS MEMBER IN ANY PURPORTED CLASS
          OR REPRESENTATIVE ACTION. Unless both you and XCIPTV Player Ultra Stream agree, no arbitrator or
          judge may consolidate more than one person’s claims or otherwise preside over any form of
          a representative or class proceeding. The arbitrator may award injunctive relief only in
          favour of the individual party seeking relief and only to the extent necessary to provide
          relief warranted by that party’s individual claim. If a court decides that applicable law
          precludes enforcement of any of this paragraph’s limitations as to a particular claim for
          relief, then that claim (and only that claim) must be severed from the arbitration and may
          be brought in court.
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <strong>
          <span>
            <br />
          </span>
        </strong>
      </p>
      <p style={{ lineHeight: 2 }}>
        <strong>
          <span>ARBITRATION RULES</span>
        </strong>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          <span>
            1.<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
        </span>
        <span>
          Either you or we may start arbitration proceedings. Any arbitration between you and XCIPTV Player Ultra Stream will take place in accordance with the prevailing&nbsp; laws of India, as
          modified by this Arbitration Agreement. You and XCIPTV Player Ultra Stream agree that the Indian
          Arbitration Act applies and governs the interpretation and enforcement of this provision
          (despite the choice of law provision above).Any arbitration hearings will take place in
          Chandigarh, India.
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          <span>
            2.<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
        </span>
        <span>
          The arbitrator may make rulings and resolve disputes as to the payment and reimbursement
          of fees or expenses at any time during the proceeding and upon request from either party
          made within 14 days of the arbitrator’s ruling on the merits.
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          <span>
            3.<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
        </span>
        <span>
          The parties to this agreement will submit all disputes arising under this agreement to
          arbitration in Chandigarh, before a single arbitrator.
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          <span>
            4.<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
        </span>
        <span>
          All disputes arising out of or in connection with the present contract shall be submitted
          to the International Court of Arbitration of the International Chamber of Commerce and
          shall be finally settled under the Rules of Arbitration of the International Chamber of
          Commerce by one or more arbitrators appointed in accordance with the said Rules.
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          <span>
            5.<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
        </span>
        <span>
          No party to this agreement will challenge the jurisdiction or venue provisions as provided
          in this section. Nothing contained herein shall prevent the party from obtaining an
          injunction.
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <strong>
          <span>
            <br />
          </span>
        </strong>
      </p>
      <p style={{ lineHeight: 2 }}>
        <strong>
          <span>NOTICE: PROCESS</span>
        </strong>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          A party who intends to seek arbitration must first send a written notice of the dispute to
          the other, by certified mail, or in the event that we do not have a physical address on
          file for you, by electronic mail (“Notice”).
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        <span>
          XCIPTV Player Ultra Stream’s address for Notice is:&nbsp;info@streamingtechllc.com&nbsp;. The Notice
          must (1) describe the nature and basis of the claim or dispute; and (2) set forth the
          specific relief sought (“Demand”). We agree to use good faith efforts to resolve the claim
          directly, but if we do not reach an agreement to do so within 30 days after the Notice is
          received, you or XCIPTV Player Ultra Stream may commence an arbitration proceeding.
          <br />
          During the arbitration, the amount of any settlement offer made by you or XCIPTV Player Ultra Stream
          shall not be disclosed to the arbitrator until after the arbitrator makes a final decision
          and award, if any. All documents and information disclosed in the course of the
          arbitration shall be kept strictly confidential by the recipient and shall not be used by
          the recipient for any purpose other than for purposes of the arbitration or the
          enforcement of the arbitrator’s decision and award and shall not be disclosed except in
          confidence to persons who have a need to know for such purposes or as required by
          applicable law.
        </span>
      </p>
      <p style={{ lineHeight: 2 }}>
        &nbsp;
        <br />
      </p>
    </div>
  );
};
